import {createContext} from 'react';
const AllegedEmailContext = createContext();
export default AllegedEmailContext;
